import { connect } from 'react-redux'

import { getUnit } from '../../ducks/unit'
import { editUnit } from '../../ducks/unit-admin'

import UnitEdit from '../UnitEdit'

export default connect(
  state => ({
    unit: state.unit.get('currentUnit'),
    isLoading: state.unitAdmin.get('isLoading')
  }),
  {
    getUnit,
    editUnit
  }
)(UnitEdit)



// WEBPACK FOOTER //
// ./src/components/smart/UnitEditContainer.js